import Currencies   from "./Currencies"
import CountryCodes from "./CountryCodes"

export default {
  [Currencies.CAD] : CountryCodes.CA,
  [Currencies.USD] : CountryCodes.US,
  [Currencies.AUD] : CountryCodes.AU,
}
